export const stringNotEmpty = (value?: string | null) => {
  if (!!value) {
    return value;
  }
  return '--';
}
